import { useRecoilState } from 'recoil';

import { useToastState } from '@/context';
import { useTimeout } from '@/hooks';
import { Toast } from '@/types';

export const useToast = (timeout = 6000) => {
  const addTimeout = useTimeout();
  const [toasts, setToasts] = useRecoilState(useToastState);

  const getId = (): number => {
    const randomValues = window.crypto.getRandomValues(new Uint32Array(1));
    const [id] = Array.from(randomValues);
    return id;
  };

  const addToast = (toast: Toast) => {
    const id = toast.id ?? getId();
    setToasts((old) => [...old, { ...toast, id }]);
    return id;
  };

  const removeToast = (id: number) => {
    setToasts((old) => old.filter((item) => item.id !== id));
  };

  const show = (toast: Toast) => {
    const id = addToast(toast);
    addTimeout(() => removeToast(id), toast.timeout || timeout, false);
    return id;
  };

  return { show, remove: removeToast, toasts };
};
